import { useMarketCitiesQuery } from '../hooks/useQueries'
import { MapCityMarker } from '../components/maps/Map'

// Map wayfinding pins: each active market, named for the state a search
// scoped to it filters by, positioned on the market's primary city
const useMarketCities = (skip: boolean): MapCityMarker[] => {
  const { data } = useMarketCitiesQuery({ skip })

  return (data?.markets ?? [])
    .filter((market) => market.searchState != null)
    .map((market) => ({
      key: market.id,
      name: market.searchState.name,
      latitude: market.primaryCity.latitude,
      longitude: market.primaryCity.longitude,
      stateCode: market.searchState.code,
      countryCode: market.country.code,
    }))
}

export default useMarketCities
